import type { ReactNode } from 'react'

import Star from '~/components/atoms/Star/Star'

import styles from './StarRating.module.css'

export interface StarRatingProps {
  id: string
  ratingValue: number
  testID?: ReactNode
}

export default function StarRating({
  id,
  ratingValue,
  testID,
}: StarRatingProps) {
  const getStars = () => {
    const starList = []
    for (let i = 0; i < Math.floor(ratingValue); i++) {
      starList.push(<Star key={`review-${id}${i}`} id={`review-${id}${i}`} />)
    }

    if (ratingValue % 1 != 0) {
      const partStar: number = parseInt(
        String(ratingValue).split('.').reverse()[0]
      )
      starList.push(
        <Star
          key={`review-part-${id}`}
          isPart={partStar}
          id={`review-part-${id}`}
        />
      )
    }

    return starList
  }
  return (
    <div className={styles.starGroup} data-testid={testID}>
      {getStars()}
    </div>
  )
}
